// Connect Firebase Auth/Firestore/Storage to the local emulator suite
// (localhost:9099/8080/9199). Build-time: set REACT_APP_USE_EMULATOR=true.
//export const isLocal = process.env.REACT_APP_USE_EMULATOR === 'true';
export const isLocal = false;